import React, { useContext,useState,useRef } from "react";
import { useHistory } from "react-router-dom";
import classNames from "classnames";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import easyinvoice from 'easyinvoice';

import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha
} from "react-google-recaptcha-v3";



import {
  CartStateContext,
  CartDispatchContext,
  removeFromCart,
  toggleCartPopup
} from "contexts/cart";
import {
  ProductsStateContext, 
  ProductsDispatchContext,
  getProducts
} from "contexts/products";




var datatest = {
  // Customize enables you to provide your own templates
  // Please review the documentation for instructions and examples
  "customize": {
      //  "template": fs.readFileSync('template.html', 'base64') // Must be base64 encoded html 
  },
  "images": {
      // The logo on top of your invoice
      "logo": "",
      // The invoice background
      "background": ""
  },
  // Your own data
  "sender": {
      "company": "AKCrackersShop",
      "city": "SivaKasi",
      "ContactNO":"+918248192299",
      "MailId": "akshophub@gmail.com"

      //"custom1": "custom value 1",
      //"custom2": "custom value 2",
      //"custom3": "custom value 3"
  },
  // Your recipient
  "client": {
      "company": "Client Corp",
      'city':""
      // "custom1": "custom value 1",
      // "custom2": "custom value 2",
      // "custom3": "custom value 3"
  },
  "information": {
      // Invoice number
      "number": "2021.0001",
      // Invoice data
      "date": "12-12-2021",
      // Invoice due date
  },
  // The products you would like to see on your invoice
  // Total values are being calculated automatically
  "products": [
      // {
      //     "quantity": "2",
      //     "description": "Product 1",
      //     "price": 33.87,
      //     "discountprice": 2342,
      //     "tax-rate":-50
      // },
      // {
      //     "quantity": "4.1",
      //     "description": "Product 2",
      //     "price": 12.34,
      //     "discountprice": 2342,
      //     "tax-rate":-50
      // },
      // {
      //     "quantity": "4.5678",
      //     "description": "Product 3",
      //     "price": 6324.453456,
      //     "discountprice": 2342,
      //     "tax-rate":-50
      // }
  ],
  // The message you would like to display on the bottom of your invoice
  "bottom-notice": "Thanks for the Order!!! / if you have any query please contact us (+912340932402) ",
  // Settings to customize your invoice
  "settings": {
      "currency": "INR", // See documentation 'Locales and Currency' for more info. Leave empty for no currency.
      // "locale": "nl-NL", // Defaults to en-US, used for number formatting (See documentation 'Locales and Currency')
      "tax-notation": "Discount Offer -", // Defaults to 'vat'
      // "margin-top": 25, // Defaults to '25'
      // "margin-right": 25, // Defaults to '25'
      // "margin-left": 25, // Defaults to '25'
      // "margin-bottom": 25, // Defaults to '25'
      // "format": "A4", // Defaults to A4, options: A3, A4, A5, Legal, Letter, Tabloid
      // "height": "1000px", // allowed units: mm, cm, in, px
      // "width": "500px", // allowed units: mm, cm, in, px
      // "orientation": "landscape", // portrait or landscape, defaults to portrait
  },
  // Translate your invoice to your preferred language
  "translate": {
      "invoice": "Order List",  // Default to 'INVOICE'
      // "number": "Nummer", // Defaults to 'Number'
      // "date": "Datum", // Default to 'Date'
      "due-date": " ", // Defaults to 'Due Date'
      // "subtotal": "Subtotaal", // Defaults to 'Subtotal'
      "products": "Crackers List", // Defaults to 'Products'
      // "quantity": "Aantal", // Default to 'Quantity'
      // "price": "Prijs", // Defaults to 'Price'
      // "product-total": "Totaal", // Defaults to 'Total'
      "total": "Super Save-Total" // Defaults to 'Total'
  },
};

var product_detail = ''


const CartPreview = () => {
  const [query, setQuery] = useState({
    "g-recaptcha-response": ""
  });
  const { items, isCartOpen } = useContext(CartStateContext);
  const dispatch = useContext(CartDispatchContext);
  const history = useHistory();
  const { products:cartItems, isLoading, isLoaded } = useContext(ProductsStateContext);
  const cartfilter = cartItems.filter( id => id.quantity > 0)
  
  const noofproduct = cartfilter.length;
  const cartDiscountTotal = cartItems
    .map((item) => item.discountprice * item.quantity)
    .reduce((prev, current) => prev + current, 0).toFixed(1);
  const cartTotal = cartItems
  .map((item) => item.price * item.quantity)
  .reduce((prev, current) => prev + current, 0).toFixed(1);
  const totalitem   = cartItems
  .map((item) => item.quantity)
  .reduce((prev, current) => prev + current, 0);
  const handleRemove = (productId) => {
    return removeFromCart(dispatch, productId);
  };
  const [ errors, setErrors ] = useState({})

  const handleProceedCheckout = () => {
    toggleCartPopup(dispatch);
    history.push("/checkout");
  };
  const [milestone, setMilestone] = useState({
    name: '',
    contactno: '',
    message: ''
  })
  const makeTimer = () => {
    setInterval(() => {
      setErrors({})
    }, 5000)
  }
  const [result,setResult]= useState({status : ''})
  const [screentoggle,setScreentoggle] = useState(true)
  
  const findFormErrors = async () => {
    const { name, contactno , messsage} = milestone
    const newErrors = {}
    // name errors

    if ( !cartfilter.length ) newErrors.name = 'Your Cart is empty, So please add the crackers...'
    if ( !name || name === '' ) newErrors.name = 'cannot be blank!'
    else if ( name.length > 30 ) newErrors.name = 'name is too long!'
    // food errors
    const Intvalue = parseInt(contactno)
    console.log(contactno.length === 10,'contactno',!isNaN(Intvalue))
    if (!( contactno.length === 10 && contactno.length !== 0 && (!isNaN(Intvalue)) )) newErrors.contactno = 'please enter 10 digit mobile number'
    console.log(Object.keys(newErrors).length === 0,'newerror')
    if (Object.keys(newErrors).length === 0 ) {
    let checkresponse = await fetch("https://akcrackershopapi.herokuapp.com/usercheck"
      , {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
	      body: JSON.stringify({name:name,contactno:contactno})
      }).then((data) => {
        return data.json()
      }, (error) => {
        if (error) {
          // handle error here
          console.log(error,'errror')
          return {status:'error'}
          
        }
      });
      console.log(checkresponse.status,'::::statuscheckresponse::::::::::')
      if (checkresponse.status === 'found') {
        newErrors.name = 'Already registered with given name and contactno.please change the name or changeno'
      }
    }
      
    return newErrors
}
const formRef = useRef(null);
  const submit = async  (e) => {
    // get our new errors
    const newErrors = await findFormErrors()

    // Conditional logic:
    e.preventDefault();
    if ( Object.keys(newErrors).length > 0 ) {
      // We got errors!
      setErrors(newErrors)
    } else {
      const current = new Date();
      const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;

      const { name, contactno , message} = milestone
      let details = {
        name: name,
        contactno: contactno,
        message: message,
        productdetail: cartfilter,
        originalprice: cartTotal,
        discountprice: cartDiscountTotal,
        noofproduct: noofproduct,
        totalitem: totalitem
      };
    
      let response = await fetch("https://akcrackershopapi.herokuapp.com/order"
      , {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify(details),
      }).then((data) => {
        return data.json()
      }, (error) => {
        if (error) {
          // handle error here
          console.log(error,'errror')
          return {status:'error'}
          
        }
      });
      // let responsetest = await fetch("http://localhost:5000/profiles"
      // , {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json;charset=utf-8",
      //   },
	    //   body: JSON.stringify({name:name,contactno:contactno})
      // }).then((data) => {
      //   return data.json()
      // }, (error) => {
      //   if (error) {
      //     // handle error here
      //     console.log(error,'errror')
      //     return {status:'error'}
          
      //   }
      // });
      //JSON.parse(responsetest.item.product)
      
      product_detail = cartfilter.concat([{   
      "category": "",
      "product": "SubTotalItem(Crackers):"+noofproduct,//
      "price": "",
      "discountprice": "MainItem",
      "quantity": ""
  },{  
      "category": "",
      "product": "TotalItem(Crackers * Quantity):"+totalitem,//
      "price": "",
      "discountprice": "TotalItems",
      "quantity": 0
  },{ 
      "category": "",
      "product": "Super Saving 50%off-"+cartTotal,//
      "price": "",
      "discountprice": "TotalPrice",
      "quantity": 0
  }])
    
     product_detail.map(i=> i['description']=i['product'])
     product_detail.map(i=>i['tax-rate']=-50)
    //  referdata.products = product_detail
    datatest.client.company = name
    datatest.client.city = contactno
     datatest.information.number = 'AK00'+contactno+'0000'
     datatest.information.date   = date
     datatest.products = product_detail
  
  // delete product_detail['price']
      console.log(response.status,':::::::::::>>>>>>>>>')
      if (response.status === 'success'){
        
      setScreentoggle(false)
      // No errors! Put any logic here for the form submission!
      easyinvoice.createInvoice(datatest, function (result) {
        easyinvoice.download('akcrackershopreferencesheet.pdf', result.pdf);
        //	you can download like this as well:
        //	easyinvoice.download();
        //	easyinvoice.download('myInvoice.pdf');   
    });
      // formRef.current.submit();
      }else{
        easyinvoice.createInvoice(datatest, function (result) {
          easyinvoice.download('akcrackershopreferencesheet.pdf', result.pdf);
          //	you can download like this as well:
          //	easyinvoice.download();
          //	easyinvoice.download('myInvoice.pdf');   
      });
        alert('Please Retry after sometime- Unable to send the request, Order is not confirm...')
        alert('Directly contact uS by below mobile no or send the pdf to below given mailid.if problem is not solved')
      }
      
      
    }
  }

  const updateMilestone = (event, property) => {
    const target = event.target
    setErrors({})
    event.preventDefault()
    setMilestone((prevState) => ({
      ...prevState,
      [property]: event.target.value,
    }))
  }
  const logout = async (e) => {
    setErrors({})
      setMilestone({
        name: '',
        contactno: '',
        message: ''
      })
    console.log('logout')
    formRef.current.submit()
  }
  const downloadpdf = async (e) => {
    easyinvoice.createInvoice(product_detail, function (result) {
      easyinvoice.download('akcrackershop_reference_sheet.pdf', result.pdf);
      //	you can download like this as well:
      //	easyinvoice.download();
      //	easyinvoice.download('myInvoice.pdf');   
  });
  } 
  return (
    
    <div className={classNames("cart-preview", { active: isCartOpen })}>
      {
       screentoggle && 
      <Container id="main-container" className="d-grid h-100">
      <GoogleReCaptchaProvider reCaptchaKey="6LcOD1IhAAAAAHWnWGcxgNO0sTlBp5rf3YKxZkuf">
      <Form ref={formRef} id="sign-in-form" className="text-center p-3 w-100">
        <h1 style={{color:"#e23d3d"}}className="mb-1 fs-3 fw-normal">Order-Form</h1>
        <Form.Group  className="mb-3" controlId="sign-in-email-address">
          <Form.Control type="text" size="md" placeholder="Enter Your Name" className="position-relative" onChange={(e) => updateMilestone(e, 'name')} isInvalid={ !!errors.name }/>
          <Form.Control.Feedback type='invalid'>
        { errors.name }
    </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className="mb-3" controlId="sign-in-password">
          <Form.Control type="phone" size="md"  placeholder="Phone Number"className="position-relative" onChange={(e) => updateMilestone(e, 'contactno')} isInvalid={ !!errors.contactno }/>
          <Form.Control.Feedback type='invalid'>
        { errors.contactno }
    </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className="mb-3" controlId="sign-in-password">
          <Form.Control type="text" size="md"  placeholder="Anything to say"className="position-relative" onChange={(e) => updateMilestone(e, 'message')}/>
          <Form.Control.Feedback type='invalid'>
        { errors.contactno }
    </Form.Control.Feedback>
        </Form.Group>
        <GoogleReCaptcha
              onVerify={(token) => {
                setQuery({ ...query, "g-recaptcha-response": token });
              }}
            />
        <div className="d-grid">
          <Button variant="danger" size="md"  onClick={(e) => submit(e)}>Submit</Button>
        </div>
        <p className="mt-3 text-muted"> Please fill the above detail, we will reach out soon.</p>
        {/* <p className="text-muted">Thank you for your inquiry</p> */}
      </Form>
      </GoogleReCaptchaProvider>
    </Container>}
    {
      !screentoggle && 
      <Container id="main-container" className="d-grid h-100">
      <Form ref={formRef} id="sign-in-form" className="text-center p-3 w-100">
      <h3 style={{color:"#e23d3d"}}className="mb-1 fs-3 fw-normal">Thank you for being our valued customer!!!</h3>
      <div className="mt-3 d-grid">
          <Button variant="dark" size="md"  onClick={(e) => downloadpdf(e) }>Download Order List</Button>
        </div>
        <div className="mt-3 d-grid">
          <Button variant="danger" size="md"  onClick={(e) => logout(e) }>Session Out</Button>
        </div>
        <p className="mt-3 text-muted"> Order list Download start. please check the download tab</p>
      </Form>

      
      </Container>

    }
         </div>
  );
};

export default CartPreview;
